import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/admin/activity');

export const getRecentActivity = async (limit = 50) => {
  const response = await apiFetch(`${API_BASE}?limit=${limit}`, {
    method: 'GET',
    auth: true,
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération de l\'activité');
  }
  
  return response.json();
};

export const getUserActivity = async (userId, limit = 20) => {
  const response = await apiFetch(`${API_BASE}/user/${userId}?limit=${limit}`, {
    method: 'GET',
    auth: true,
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération de l\'activité utilisateur');
  }
  
  return response.json();
};

export const getActivityByDateRange = async (startDate, endDate) => {
  const response = await apiFetch(`${API_BASE}/range?start_date=${startDate}&end_date=${endDate}`, {
    method: 'GET',
    auth: true,
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de la récupération de l\'activité par période');
  }
  
  return response.json();
};
